<template>
    <!--打印小票-->
    <div class="popBg" v-if="printState">
        <div class="print-box">
            <div class="print-head">
                打印小票
            </div>
            <div class="print-body" id="ticket-body">
                <div v-if="!isArr">
                    <ticket-tpl :data="ticketData"></ticket-tpl>
                </div>
                <div v-else>
                    <ticket-tpl v-for="(data, key) in ticketData" :key="key" :data="data"></ticket-tpl>
                </div>
            </div>
            <div class="print-foot">
                <div class="print-foot">
                    <el-button size="small" @click="close">取消</el-button>
                    <el-button size="small" type="primary" @click="printTicket">打印</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PopForm from "@/model/PopForm";
    import TicketTpl from "@/model/Cash/TicketTpl";
    import printJS from 'print-js';
    import obj from "@/js/obj";
    export default {
        name: "TicketPrint",
        components: {TicketTpl, PopForm},
        model: {
            prop: "printState",
            event: "showChange"
        },
        props: {
            printState: {
                type: Boolean,
                default: false
            },
            ticketData: {
                type: [Array, Object],
                default: {}
            }
        },
        data: () => ({
            isArr: false
        }),
        mounted: function () {

        },
        methods: {
            //打印小票
            printTicket: function () {
                printJS({
                    printable: 'ticket-body',
                    type: 'html',
                    scanStyles: false,
                    css: '/style/PostTicket.css',
                });
                this.close();
            },
            //关闭
            close: function () {
                this.$emit("showChange", false);
            }
        },
        watch: {
            printState: function (val) {
                if(obj.isEmpty(this.ticketData[0]))
                    this.isArr = false;
                else
                    this.isArr = true;
            }
        }
    }
</script>

<style scoped>
    .popBg{
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 999;
        overflow-y: auto;
    }
    .print-box{
        width: 320px;
        margin: 10px auto;
        background-color: #FFFFFF;
        border-radius: 5px;
    }
    .print-box .print-head{
        font-size: 18px;
        color: #333333;
        height: 60px;
        line-height: 60px;
        padding: 0px 16px;
        border-bottom: 1px solid #eaeaea;
        text-align: left;
    }
    .print-body{
        width: 320px;
        margin: 0 auto;
    }
    .print-foot{
        padding: 0px 10px 10px;
        text-align: right;
    }
</style>
